import { get, post } from './mainApi';

const workLogServiceBaseURL = process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT;

export const getSkillsOverview = async () => {
  var response = get(workLogServiceBaseURL + '/resources/skill-view');
  return response;
};

export const getSkillsList = async () => {
  var response = get(
    workLogServiceBaseURL + '/resources/skill-allocation-resources'
  );
  return response;
};

export const getSingleSkill = async (skill: any) => {
  var response = post(
    `${workLogServiceBaseURL}/resources/skill-allocation-resources/skill-wise`,
    skill
  );
  return response;
};
